module.exports = __webpack_public_path__ + "static/media/project1.d50682a6.jpeg";